package fr.manyverse.app.presentation.components.modules.timer

internal fun formatCountdown(totalSeconds: Int): String {
    val hoursIntValue = totalSeconds / 3600
    val hours = hoursIntValue.toString().padStart(2, '0')
    val minutes = ((totalSeconds % 3600) / 60).toString().padStart(2, '0')
    val seconds = (totalSeconds % 60).toString().padStart(2, '0')
    return if (hoursIntValue > 0) "$hours:$minutes:$seconds" else "$minutes:$seconds"
}

internal fun formatSecondsToHhMmSs(totalSeconds: Int): String {
    val hours = (totalSeconds / 3600).toString().padStart(2, '0')
    val minutes = ((totalSeconds % 3600) / 60).toString().padStart(2, '0')
    val seconds = (totalSeconds % 60).toString().padStart(2, '0')
    return "$hours:$minutes:$seconds"
}

internal fun parseHhMmSs(text: String): Int? {
    val parts = text.split(":")
    return try {
        when (parts.size) {
            3 -> {
                val hours = parts[0].toIntOrNull() ?: return null
                val minutes = parts[1].toIntOrNull() ?: return null
                val seconds = parts[2].toIntOrNull() ?: return null
                hours * 3600 + minutes * 60 + seconds
            }
            2 -> {
                val minutes = parts[0].toIntOrNull() ?: return null
                val seconds = parts[1].toIntOrNull() ?: return null
                minutes * 60 + seconds
            }
            1 -> parts[0].toIntOrNull()
            else -> null
        }
    } catch (_: Exception) {
        null
    }
}
